import { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';

const APP_WEB_URL = 'https://app.locjah.com.br';

function DeepLinkRedirect() {
  const { orderGuid, ownerName } = useParams();
  const location = useLocation();

  useEffect(() => {
    // Android App Links / iOS Universal Links should have opened the app before
    // the browser ever loaded this page. Reaching here means the app is not
    // installed or an in-app browser (e.g. WhatsApp WebView) bypassed interception.
    // In both cases, redirect to the web app preserving the deep-link target.
    let webUrl;
    if (orderGuid) {
      webUrl = `${APP_WEB_URL}/orders-summary-detail?orderGuid=${orderGuid}`;
    } else if (ownerName) {
      webUrl = `${APP_WEB_URL}/?ownerName=${encodeURIComponent(ownerName)}`;
    } else {
      // Legacy: /orders-summary-detail?orderGuid=
      const params = new URLSearchParams(location.search);
      const legacyGuid = params.get('orderGuid');
      webUrl = legacyGuid
        ? `${APP_WEB_URL}/orders-summary-detail?orderGuid=${legacyGuid}`
        : APP_WEB_URL;
    }

    window.location.replace(webUrl);
  }, [orderGuid, ownerName, location.search]);

  return null;
}

export default DeepLinkRedirect;
